export function getAggregateData(data: any, aggregateKeys: string[]) {
	let aggregateCount = 0;
	aggregateKeys.forEach((key: string) => {
		if (data[key] != null && !isNaN(data[key])) aggregateCount += data[key];
	});
	return aggregateCount;
}
